import * as yup from 'yup'

export const invoiceAddressValidationSchema = yup.object({
  street: yup
    .string()
    .min(3, 'Street must be at least 3 characters.')
    .required('Street is required'),
  number: yup.string(),
  zip_code: yup
    .string()
    .required('ZIP Code is required.')
    .matches(
      /(^\d{5}$)|(^\d{9}$)|(^\d{5}-\d{4}$)/gm,
      'Invalid ZIP Code format (XXXXX, XXXXXXXXX or XXXXX-XXXX).',
    ),
  city: yup.string().min(3, 'City must be at least 3 characters.').required('City is required.'),
  country: yup
    .string()
    .min(3, 'Country must be at least 3 characters.')
    .required('Country is required.'),
})

export const companyValidationSchema = yup.object({
  name: yup.string().min(3).required('Company name is required'),
  // aliases: yup
  //   .array()
  //   .min(1, 'Company must be at least 1 alias')
  //   .of(yup.string().min(2, 'Initials must be at least 2 characters')),
  // initials: yup
  //   .string()
  //   .min(2, 'Initials must be at least 2 characters.')
  //   .required('Company initials is required'),
  address: yup.lazy((value) => {
    if (value !== undefined && value !== null) {
      return yup
        .object({
          line_1: yup
            .string()
            .min(3, 'Address Line 1 must have at least 3 characters')
            .required('Field required'),
          line_2: yup.string().optional(),
          city: yup.string().optional(),
          state_province: yup.string().optional(),
          zip: yup.string().optional(),
          country: yup.string().optional(),
        })
        .nullable()
        .optional()
    }
    return yup.mixed().notRequired()
  }),
})
export const contactInfoValidationSchema = yup.object({
  tech_focal: yup
    .string()
    .min(3, 'Name must be at least 3 characters')
    .required('Name is required'),
  tech_email: yup.string().email('Should be a valid email').required('Email is required'),
  tech_cellphone: yup.string(),
  tech_phone: yup.string(),
  tech_function: yup.string().required('Function is required'),
})

export const invoiceInfoValidationSchema = yup.object({
  fin_focal: yup
    .string()
    .min(3, 'Name must be at least 3 characters.')
    .required('Name is required'),
  fin_email: yup.string().email('Should be a valid email').required('Email is required'),
  fin_phone: yup.string().min(6, 'Phone must be at least 6 numbers').required('Phone is required'),
  invoice_to_address: yup
    .array()
    .min(1, 'At least one address is required')
    .of(invoiceAddressValidationSchema),
})

export const inspectionContactInfoValidationSchema = yup.object({
  name: yup.string().min(3, 'Name must be at least 3 characters.').required('Name is required'),
  email: yup.string().email('Should be a valid email').required('Email is required'),
  phone: yup.string(),
  cellphone: yup.string(),
})
